import { environment } from './../environments/environment.prod';
import { Layout } from './preset/preset.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig, EnvironmentName, EnvironmentNames } from './models/app-config.model';
import { IAppVersion } from './models/app-version.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  static settings: IAppConfig;
  static version: IAppVersion;
  static appName: string;
  static appMap: any;
  static presets: Layout[];
  static chanels :any
  public environmentName: EnvironmentName; 
  private readyPromise: Promise<void>; 
  private jsonFile = `assets/config/config.${environment.name}.json`;
  
  static get validateToken() {
    return this.settings.environment === EnvironmentNames.Aws;
  }
  
  waitUntil() :Promise<void>{
    return this.readyPromise || this.load();
  }

  constructor(private http: HttpClient) { }

  load() {
    this.readyPromise = this.http.get(this.jsonFile).toPromise().then((response: IAppConfig) => {
      AppConfig.settings = <IAppConfig>response;
      this.environmentName = AppConfig.settings.environment;
      return Promise.all([
        this.loadVersion(),
        this.loadMapStyle(),
        this.loadPreset(),
        this.loadChanels()
        ]);
      }).then(() => undefined).
      catch((response: any) => {
        console.error(`Could not load file '${this.jsonFile}': ${JSON.stringify(response)}`);
      });
    return this.readyPromise;
  }

  loadVersion() {
    const jsonFile = `assets/config/version.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: IAppVersion) => {
        AppConfig.version = <IAppVersion>response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }
  loadMapStyle() {
    const jsonFile = `assets/config/MapStyle.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: any) => {
        AppConfig.appMap = response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }
  loadPreset() {
    const jsonFile = `assets/config/presets.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: any) => {
        AppConfig.presets = response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }

  loadChanels() {
    const jsonFile = `assets/config/chanels.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: any) => {
        AppConfig.chanels = response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }
}
